<template>
  <div class="animated fadeIn" id="detailInsentifEngineerManager">
      <h3>INSENTIF MANAGER</h3> <br>
      <strong style="text-transform: capitalize;"> {{type_ticket}} </strong>
      <br>
      Insentif : {{prices | pointmoney}}
      <!-- <button class="btn btn-primary" @click="excel">Excel</button> -->
    <br>
          <table class="table table-bordered" id="detailManager">
              <thead>
                  <tr>
                    <th>No</th>
                    <th>PIC</th>
                    <th>Point</th>
                    <th>Ticket Id</th>
                    <th>Account Name</th>
                    <th>Create</th>
                    <th>Solved</th>
                    <th>Close</th>
                    <th>Detail</th>
                  </tr>
              </thead>
              <tbody>
                  <template v-for="(detail, i) in detailTickets">
                      <tr :key="i">
                        <td>{{i+ 1}}</td>
                        <td>{{detail.pic_name}}</td>
                        <td align="center">{{detail.poin}}</td>
                        <td>
                            <a  :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + detail.ticket_id" target="_blank">
                             {{detail.ticket_id}}
                            </a>
                        </td>
                        <td>
                            <a :href="'https://isx.nusa.net.id/customer.php?custId=' + detail.CustId + '&pid=profile&module=customer'" target="_blank" >
                            {{detail.CustAccName}}
                            </a>
                        </td>
                        <td>{{detail.ticket_create}}</td>
                        <td>{{detail.solved_time}} </td>
                        <td>{{detail.closed_time}}</td>
                        <td>{{detail.problem}}</td>
                      </tr>
                  </template>
                  <template v-if="detailTickets.length == 0">
                      <tr class="bg-warning">
                          <td colspan="8">
                              No Ticket
                          </td>
                      </tr>
                  </template>
              </tbody>
          </table>
  </div>
</template>
<script>
export default {
    data() {
        return {
            detailTickets: [],
            type_ticket: '',
            prices: 0,
        }
    },
    created() {
       this.typedetail = this.typeTicket
    },
    props: {
        typeTicket: {
          type: String,
          default: '',
        },
        detailTicket: {
            type: Array,
            default: () => []
        },
        price: {
            type: Number,
            default: 0
        }
    },
    watch: {
        detailTicket () {
           this.detailTickets = this.detailTicket 
        },
        typeTicket () {
            this.type_ticket = this.typeTicket
        },
        price() {
            this.prices = this.price
        }
    },
    created () {
        this.detailTickets = this.detailTicket 
        this.type_ticket = this.typeTicket 
        this.prices = this.price
    },
    methods: {
        excel() {
            return tableToExcel('detailManager', 'Insentif Manager')
        }
    }
}

var tableToExcel = (function() {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  return function(table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
    window.location.href = uri + base64(format(template, ctx))
  }
})()
</script>
